module.exports = __webpack_public_path__ + "img/king-charles-i.d2d5f085.png";